import React from "react";
import { rng } from "../../amorg-common";
import { Modal } from "../Modal";
import { Button } from "../button/Button";
import { ButtonVariant } from "../button/Shared";
import { colors } from "../colors/color";
import { iconName } from "../icons/Icons";
import { TextInput } from '../inputs/TextInput';
import { Small } from "../typography/Body";
import { Flex } from "./FlexHelpers";

type ConfirmationButtonProps = {
    icon?:iconName,
    title?: string,
    buttonText: string,
    content: React.ReactNode,
    requireKey: boolean,
    onConfirm: () => void,
    disabled?:boolean,
    fullWidth?:boolean,
    modalButtonVariant?: ButtonVariant
    confirmButtonVariant?: ButtonVariant
}
export function ConfirmationButton(props: ConfirmationButtonProps): JSX.Element {
    const [showModal, setShowModal] = React.useState(false);

    function handleClickButton() {
        setShowModal(true);
    }

    function handleConfirmClick() {
        props.onConfirm();
        setShowModal(false);
    }

    return (
        <>
            <Button
                variant={props.modalButtonVariant  || "outlined"}
                onClick={() => handleClickButton()}
                icon={props.icon}
                text={props.buttonText}
                disabled={props.disabled} 
            />
                

            <ConfirmationModal 
                showModal={showModal} 
                {...props}
                onCancel={() => setShowModal(false)}
                onConfirm={handleConfirmClick} />

        </>
    )
}

type ConfirmationModalProps = {
    showModal:boolean,
    asIcon?: boolean,
    title?: string,
    content: React.ReactNode,
    requireKey: boolean,
    buttonText: string,
    confirmButtonVariant?: ButtonVariant
    onConfirm: () => void,
    onCancel: () => void,
}
export function ConfirmationModal(props:ConfirmationModalProps):JSX.Element
{
    const [confirmationKey, setConfirmationKey] = React.useState('');
    const [confirmationInput, setConfirmationInput] = React.useState('');

    React.useEffect(()=>{
        setConfirmationKey(getConfirmationKey());
        setConfirmationInput('');
    }, [props.showModal])

    function getConfirmationKey() {
        return rng.getRandomCharacters(
            4,
            ['upper']
        )
    }

    function handleConfirmationInputChange(value: string) {
        setConfirmationInput(value);
    }

    return (
        
        <Modal
            title={props.title}
            showModal={props.showModal}
            onCancel={props.onCancel}
            content={
                <Flex gap={16} justifyContent={"center"} flexDirection="column" alignItems="center">
        
                <Flex justifyContent="center" gap={16}>
                    {props.content}
                </Flex>
        
                {props.requireKey &&
                <Flex flexDirection="column" gap={16}>
                    <Flex flexDirection="row" gap={8}>
                        <span style={{ padding: '10px', border: `1px solid ${colors.text.state.error}` }}>
                            <b>{confirmationKey}</b>
                        </span>
                        <TextInput value={confirmationInput} onChange={handleConfirmationInputChange} />
                    </Flex>
                    <Flex justifyContent="center">
                        <Small>
                        Indtast koden for at bekræfte
                        </Small>
                    </Flex>
                </Flex>
                }

                <Flex justifyContent="space-between" width="100%">
                    
                    <Button 
                        onClick={props.onCancel}
                        variant="text"
                        icon={'cancel'}
                        text={"Annuller"} />
                    <Button 
                        onClick={props.onConfirm}
                        variant={props.confirmButtonVariant || "filled"}
                        disabled={props.requireKey && confirmationInput !== confirmationKey}
                        icon={"status_ok"}
                        text={props.buttonText} />
                    
                </Flex>
            </Flex>        
            }
        />
    );
}